// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__Nv4hn","loaderOuter":"PageOverlayLoader_loaderOuter__3YP4l"};